import { v4 as uuidv4 } from "uuid"
import delay from "./delay"
import { toast } from "react-toastify"

let socket
let reconnectTimeout
const url = "ws://127.0.0.1"
const port = "12345"

let isBusy = false
const messageQueue = []

const handleError = () => {
  socket.removeEventListener("error", handleError)

  socket.removeEventListener("open", handleOpened)

  reconnectTimeout = setTimeout(() => connect(), 2000)

  socket.close()
}

const handleOpened = () => {
  toast.info("مرورگر به پرینتر متصل شد") 
}

const connect = () => {
  socket = new WebSocket(`${url}:${port}`)

  socket.addEventListener("open", handleOpened)

  socket.addEventListener("error", handleError)
}

const createConnection = () => {
  connect()
}

const disconnect = () => {
  clearTimeout(reconnectTimeout)

  socket.close()

  socket.removeEventListener("error", handleError)
}

const dequeue = async () => {
  if (messageQueue.length === 0) return isBusy = false

  isBusy = true

  const { data, resolve, reject } = messageQueue.shift()

  if (!socket) {
    reject("Socket is not open")

    return dequeue()
  }

  if (socket.readyState !== socket.OPEN) {
    reject("Socket is not open")

    return dequeue()
  }

  await delay(400)

  const socketMessageId = uuidv4()

  socket.send(
    JSON.stringify({ socketMessageId, data })
  )

  const handleReceive = (e) => {
    const message = JSON.parse(e.data || "")

    if (message.socketMessageId !== socketMessageId) return

    resolve(message.data)

    socket.removeEventListener("message", handleReceive)
  }

  socket.addEventListener("message", handleReceive)

  dequeue()
}

const send = (data) => (
  new Promise((resolve, reject) => {
    messageQueue.push({ data, resolve, reject })

    if (isBusy) return

    dequeue()
  })
)

const websocketApi = {
  send,
  disconnect,
  createConnection
}

export default websocketApi